import { IMyDate } from './IMyDate';
import { IsNotEmpty } from 'class-validator';
import { Type } from 'class-transformer';

export class IMyDateRangeModel {
  @IsNotEmpty()
  @Type(() => IMyDate)
  beginDate: IMyDate;
  @IsNotEmpty()
  @Type(() => IMyDate)
  endDate: IMyDate;
}
